module.exports = __webpack_public_path__ + "img/17588de.jpg";